import React from "react";
import { required } from "../../../../../utils/forms/validators";
import { Field } from "redux-form";
import Input from "../../../../../components/common/input/Input";
import Select2 from "../../../../../components/common/select/Select2";
import { Row, Col } from "react-bootstrap";
import styles from "./ReferenceFormField.scss";

export const ReferenceFormFields = props => {
  const { referenceRelationships } = props;
  const [md, sm, xs] = [6, 8, 12];

  return (
    <React.Fragment>
      <Row className={styles.noPadding}>
        <Col md={md} sm={sm} xs={xs} className={styles.noPadding}>
          <Field
            name="name"
            type="text"
            placeholder="Your Name"
            component={Input}
            validate={required}
            autoComplete="rnd-str"
            autoFill="off"
          />
        </Col>
      </Row>
      <Row className={styles.noPadding}>
        <Col md={md} sm={sm} xs={xs} className={styles.noPadding}>
          <Field
            name="current_company"
            placeholder="Your Current Company"
            component={Input}
            validate={required}
            autoComplete="rnd-str"
            autoFill="off"
          />
        </Col>
      </Row>
      <Row className={styles.noPadding}>
        <Col md={md} sm={sm} xs={xs} className={styles.noPadding}>
          <Field
            name="worked_company"
            placeholder="Company Where You Worked Together"
            component={Input}
            validate={required}
            autoComplete="rnd-str"
            autoFill="off"
          />
        </Col>
      </Row>
      <Row className={styles.noPadding}>
        <Col md={md} sm={sm} xs={xs} className={styles.noPadding}>
          <Field
            name="relationship"
            type="select"
            placeholder="Relationship"
            component={Select2}
            options={referenceRelationships}
          />
        </Col>
      </Row>
      <Row className={styles.noPadding}>
        <Col md={md} sm={sm} xs={xs} className={styles.noPadding}>
          <Field
            name="worked_together_for"
            type="text"
            placeholder="Number of Years You Worked Together"
            component={Input}
            validate={required}
            autoComplete="rnd-str"
            autoFill="off"
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/routes/admin/reference/components/Reference/ReferenceFormFields.js